//@config
export default {
  report: {
    payments: "v1/payments",
    myPayments: "v1/my-payments",
    final_report: "v1/final_report",
    final_report_votes: "v1/final_report/{0}/votes",
    final_report_general: "v1/final_report/{0}/general",
    final_report_specialty: "v1/final_report/{0}/specialty",
    final_report_attitude: "v1/final_report/{0}/attitude",
    final_report_intuition: "v1/final_report/{0}/intuition",
    final_report_behavioral: "v1/final_report/{0}/behavioral",
    final_report_resource: "v1/final_report/{0}/resource",
    report_person_result: "v1/report_person_result/{0}",
    final_report_entering_azmoon: "v1/final_report/{0}/entering_azmoon",
    final_report_score: "v1/final_report/{0}/score?group_id={1}",
    final_report_research: "v1/final_report/{0}/research",
    final_report_set_current_parvandeh: "v1/final_report/{0}/see_head_team",
    final_report_see_head_team: "v1/final_report_see_head_team",
    export_main: "v1/export/mine",
    attachment_download: "v1/attachment/download/{0}",
    ready_report: "v1/ready_report",
    ready_report_generate: "v1/ready_report/{0}",
    ready_report_export_resource: "v1/export/ready_report",
    ready_report_access: "v1/ready_report_access",
    ready_report_combo: "v1/ready_report_combo",
    user_combo: "v1/user-combo",
    final_report_images: "v1/final_report_images?parvandeh_code={0}",
    ready_qualification: "v1/ready_qualification",
    final_report_exam_pack_parvandeh: "v1/final_report/{0}/exam_pack",
    final_report_exam_pack: "v1/final_report_exam_pack",
    final_report_exam_pack_id: "v1/final_report_exam_pack/{0}",
    final_report_status: "v1/final_report/{0}/status",
    person_education: "v1/person/{0}/education",
    research_exam_packs: "v1/final_report/{0}/selected_exam_pack",
    research_summary: "v1/research_summary/{0}",
    final_report_research_summary: "v1/final_report/{0}/research_summary",
    final_report_exception: "v1/final_report_exception",
    final_report_conclusion: "v1/final_report/{0}/conclusion",
    payment_no_need: "v1/payment_no_need",
    payment_no_need_id: "v1/payment/{0}/payment_no_need",
    payment_no_need_id_code: "v1/payment/{0}/payment_no_need/{1}",
    term_state_combo: "v1/term_state_combo",
    company_parvandeh_report: "v1/company_parvandeh_report",
    summary_parvandeh: "v1/summary_parvandeh",
    competency_washup_scores: "v1/competency_washup_scores",
    dashboard_report: "v1/dashboard_report",
    dashboard_report_type: "v1/dashboard_report_type",
    summaryParvandehExport: "v1/summary_parvandeh_export",
    parvandehInquiries: "v1/parvandeh/{0}/inquiries",
  },
};
